module.exports = __webpack_public_path__ + "static/img/introduction_img.ad7f8631.png";